import React from 'react';
export function BeforeAfter() {
  return <section id="gallery" className="py-24 bg-white border-y border-slate-200" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="font-display text-4xl md:text-5xl text-slate-900 uppercase tracking-wide mb-4" data-id="element-15">
            Recent <span className="text-accent" data-id="element-16">Projects</span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-17">
            Take a look at some of our recent home improvement and repair
            projects across Oklahoma.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-18">
          <div className="flex flex-col gap-4" data-id="element-19">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-slate-200 shadow-xl" data-id="element-20">
              <img src="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?q=80&w=800&auto=format&fit=crop" alt="Plumbing Repair" className="w-full h-full object-cover" data-id="element-21" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 text-center" data-id="element-22">
              Plumbing Repairs
            </h3>
          </div>
          <div className="flex flex-col gap-4" data-id="element-23">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-slate-200 shadow-xl" data-id="element-24">
              <img src="https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=80&w=800&auto=format&fit=crop" alt="Home Improvement" className="w-full h-full object-cover" data-id="element-25" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 text-center" data-id="element-26">
              Home Improvements
            </h3>
          </div>
          <div className="flex flex-col gap-4" data-id="element-27">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-slate-200 shadow-xl" data-id="element-28">
              <img src="https://images.unsplash.com/photo-1581094288338-2314dddb7ece?q=80&w=800&auto=format&fit=crop" alt="Well Pump Service" className="w-full h-full object-cover" data-id="element-29" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 text-center" data-id="element-30">
              Well Pump Services
            </h3>
          </div>
        </div>
      </div>
    </section>;
}